import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { ContactCardContent } from '@src/authentication/ContactCardContent';
import { Card } from '@src/common/components/Card';
import { Stack } from '@src/common/components/Stack';
import { theme } from '@src/common/styles/Theme';
import type { User } from '@src/manageUsers/domain/User';
import React from 'react';

type Props = {
  user: User | null;
};

export const ContactCard: React.FC<Props> = ({ user }) => {
  return (
    <Card
      aria-label={
        user ? `contact-${user.id}-details` : 'no-agent-contact-details'
      }
    >
      <Stack direction="row" gap={theme.spacing[3]} padding={theme.spacing[2]}>
        <AccountCircleIcon style={{ fontSize: 60 }} />
        <ContactCardContent
          id={user?.id}
          extension={user?.extension}
          name={user?.name}
          email={user?.email}
        />
      </Stack>
    </Card>
  );
};
